import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService, LoadingPanelSettings } from './loading-panel.service';
import { DxLoadPanelModule } from 'devextreme-angular';

@Component({
    selector: 'ep-loading-panel',
    templateUrl: './loading-panel.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxLoadPanelModule]
})
export class LoadingPanelComponent implements OnInit {
    public message: string;
    public showLoadingPanel = false;
    public isModal = true;

    constructor(private loadingPanelService: LoadingPanelService) { }

    ngOnInit() {
        this.loadingPanelService.loadingPanelShowSubscriber.subscribe((settings: LoadingPanelSettings) => {
            this.message = settings.message;
            this.isModal = settings.modal;
            this.showLoadingPanel = true;
        });

        this.loadingPanelService.loadingPanelHideSubscriber.subscribe(() => {
            this.showLoadingPanel = false;
        });
    }
}
